export function formatPriceRangeMillion(from, to, { withCurrency = false } = {}) {
  // Hiển thị khi chỉ có một đầu giá là tạm theo Q-G(a).
  let result = "";
  if (from != null && to != null) result = from === to ? `${from} triệu` : `${from} – ${to} triệu`;
  else if (to != null) result = `Dưới ${to} triệu`;
  else if (from != null) result = `Từ ${from} triệu`;
  return result && withCurrency ? `${result} VNĐ` : result;
}
